var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3.375C9.9225 3.375 3.375 9.9225 3.375 18C3.375 26.0775 9.9225 32.625 18 32.625C26.0775 32.625 32.625 26.0775 32.625 18C32.625 9.9225 26.0775 3.375 18 3.375ZM19.125 13.5C19.125 13.2016 19.0065 12.9155 18.7955 12.7045C18.5845 12.4935 18.2984 12.375 18 12.375C17.7016 12.375 17.4155 12.4935 17.2045 12.7045C16.9935 12.9155 16.875 13.2016 16.875 13.5V16.875H13.5C13.2016 16.875 12.9155 16.9935 12.7045 17.2045C12.4935 17.4155 12.375 17.7016 12.375 18C12.375 18.2984 12.4935 18.5845 12.7045 18.7955C12.9155 19.0065 13.2016 19.125 13.5 19.125H16.875V22.5C16.875 22.7984 16.9935 23.0845 17.2045 23.2955C17.4155 23.5065 17.7016 23.625 18 23.625C18.2984 23.625 18.5845 23.5065 18.7955 23.2955C19.0065 23.0845 19.125 22.7984 19.125 22.5V19.125H22.5C22.7984 19.125 23.0845 19.0065 23.2955 18.7955C23.5065 18.5845 23.625 18.2984 23.625 18C23.625 17.7016 23.5065 17.4155 23.2955 17.2045C23.0845 16.9935 22.7984 16.875 22.5 16.875H19.125V13.5Z",
    fill: "#00B982"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.d5a412e7589772a4da6e9b59b4780a67.svg";
export { ForwardRef as ReactComponent };